import React from 'react';

const Cell = ({ value, label, onDark }) => (
  <div
    className={`min-w-[62px] md:min-w-[76px] rounded-xl px-3 py-2 text-center ${
      onDark ? 'bg-white/10 border border-white/15' : 'bg-[#3D4A26]/8 border border-[#3D4A26]/15'
    }`}
  >
    <p
      className={`text-xl md:text-3xl font-bold leading-none tabular-nums ${onDark ? 'text-white' : 'text-[#1B1B1B]'}`}
      style={{ fontFamily: 'DM Sans, sans-serif' }}
    >
      {String(value).padStart(2, '0')}
    </p>
    <p
      className={`mt-1 text-[9px] md:text-[10px] uppercase tracking-[0.18em] font-semibold ${
        onDark ? 'text-white/60' : 'text-[#3D4A26]/70'
      }`}
    >
      {label}
    </p>
  </div>
);

/** Countdown cells, or a status pill once the event started / finished. */
const EventCountdown = ({ status, parts, onDark = true, testId = 'event-countdown' }) => {
  if (status !== 'upcoming') {
    return (
      <p
        data-testid={`${testId}-status`}
        className={`inline-flex items-center gap-2 rounded-full px-4 py-2 text-xs md:text-sm font-bold ${
          onDark ? 'bg-[#C8D843] text-[#1B1B1B]' : 'bg-[#3D4A26] text-white'
        }`}
      >
        {status === 'ongoing' ? 'Etkinlik devam ediyor' : 'Bu etkinlik tamamlandı'}
      </p>
    );
  }

  return (
    <div data-testid={testId} className="flex items-center gap-2 md:gap-3">
      <Cell value={parts.days} label="Gün" onDark={onDark} />
      <Cell value={parts.hours} label="Saat" onDark={onDark} />
      <Cell value={parts.minutes} label="Dakika" onDark={onDark} />
    </div>
  );
};

export default EventCountdown;
